import AlertItem from "./AlertItem";

const AlertList = ({ alerts, activeTab }) => {
    // Handle null or undefined alerts
  if (!alerts || alerts.length === 0) {
    return <div className="text-center p4 pb-3">No alerts available.</div>;
  }

  // Filter alerts based on the active tab
  const filteredAlerts = alerts.filter((alert) =>
    activeTab === "All" ? true : `${alert.alert_type}s` === activeTab.toLowerCase()
  );

  return (
    <div className="mt-3 pb-2 px-3">
      {/* Column Names Header */}
        <div className="d-flex  mx-2 p-3 fw-bold fs-5" style={{ backgroundColor: "#EDF7F9", borderRadius: "10px 10px 0px 0px" }}>
        {/* Column Names Header */}
        <div className="d-block d-sm-none col-12 text-center fw-bold">Alerts</div> {/* Show 'Alerts' on small screens only */}
        <div className="d-none d-sm-flex col-sm-2  ">From</div>
        <div className="d-none d-sm-flex col-sm-7 me-1 ">Message</div>
        <div className="d-none d-sm-flex col-sm-2 me-1 ">Date & Time</div>
        <div className="d-none d-sm-flex col-sm-1 me-1  ">Action</div>
        </div>

      {/* Alert List */}
      {filteredAlerts.length > 0 ? (
        filteredAlerts.map((alert, index) => (
          <AlertItem
            key={index}
            alert={alert}
            index={index}
            totalItems={filteredAlerts.length} // Pass total length of the list
          />
        ))
      ) : (
        <div className="text-center pb-3">No alerts found.</div>
      )}
    </div>
  );
};

export default AlertList;
